import { getObjectKeysAsObject } from "@checkout/helpers";
import type { CartContext } from "../context";
import { getCartUpdateParams } from "./selectors";

export const guards = {
  isUpdateQuoteRequestEmpty: (context: CartContext, _event: unknown) => {
    const cartUpdateCtx = getCartUpdateParams({ context });
    return (
      !cartUpdateCtx.addPayments.length &&
      !cartUpdateCtx.addProducts.length &&
      !cartUpdateCtx.removePayments.length &&
      !cartUpdateCtx.removeProducts.length
    );
  },
};

export const GuardTypes = getObjectKeysAsObject(guards);
